module.exports = __webpack_public_path__ + "assets/img/Arty_Gasparina.4165ef63-ps.jpg";